import { Dispatch, SetStateAction, useState } from "react";
import {
  Modal,
  Button,
  MenuItem,
  Select,
  TextField,
  Box,
  IconButton,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import AccessTimeIcon from "@mui/icons-material/AccessTime";

interface ModalProps {
  open: boolean;
  onClose: () => void;
  setOpen: Dispatch<SetStateAction<boolean>>;
}

export default function ScheduleReportModal({
  open,
  onClose,
  setOpen,
}: ModalProps) {
  const [recipients, setRecipients] = useState<string[]>([""]);
  const [email, setEmail] = useState("");

  const addRecipient = () => {
    if (email.trim()) {
      setRecipients([...recipients, email.trim()]);
      setEmail("");
    }
  };

  return (
    <Modal className="modal" open={open} onClose={onClose}>
      <div className="modal-dialog">
        <div className="modal-body">

          {/* Header */}
          <div className="modal_title">
            <h2>Schedule Report</h2>
            <button
              type="button"
              className="btn-close"
              onClick={() => setOpen(false)}
            >
              <CloseIcon />
            </button>
          </div>

          {/* Form */}
          <form className="form">
            <div className="gap_p">

              {/* Saved Query */}
              <div className="control_group">
                <label htmlFor="report-saved-query">Saved Query</label>
                <Select fullWidth defaultValue="" displayEmpty inputProps={{ id: "report-saved-query" }}>
                  <MenuItem value="" disabled>
                    Select a saved query...
                  </MenuItem>
                  <MenuItem value="query1">UAE E-commerce Report</MenuItem>
                  <MenuItem value="query2">Sales Performance</MenuItem>
                </Select>
              </div>

              {/* Frequency */}
              <div className="control_group">
                <label htmlFor="report-frequency">Frequency</label>
                <Select fullWidth defaultValue="weekly" inputProps={{ id: "report-frequency" }}>
                  <MenuItem value="one_time">One Time</MenuItem>
                  <MenuItem value="daily">Daily</MenuItem>
                  <MenuItem value="weekly">Weekly</MenuItem>
                  <MenuItem value="monthly">Monthly</MenuItem>
                </Select>
              </div>

              {/* Day of Week */}
              <div className="control_group">
                <label htmlFor="report-day">Day of Week</label>
                <Select fullWidth defaultValue="monday" inputProps={{ id: "report-day" }}>
                  <MenuItem value="Sunday">Sunday</MenuItem>
                  <MenuItem value="monday">Monday</MenuItem>
                  <MenuItem value="tuesday">Tuesday</MenuItem>
                  <MenuItem value="wednesday">Wednesday</MenuItem>
                  <MenuItem value="Thursday">Thursday</MenuItem>
                  <MenuItem value="Friday">Friday</MenuItem>
                  <MenuItem value="Saturday">Saturday</MenuItem>
                </Select>
              </div>

              {/* Time */}
              <div className="control_group">
                <label htmlFor="report-time">Time</label>
                <TextField fullWidth hiddenLabel type="time" inputProps={{ id: "report-time" }} />
              </div>

              {/* Format */}
              <div className="control_group">
                <label htmlFor="report-format">Format</label>
                <Select fullWidth defaultValue="pdf" inputProps={{ id: "report-format" }}>
                  <MenuItem value="pdf">PDF</MenuItem>
                  <MenuItem value="excel">Excel</MenuItem>
                  <MenuItem value="csv">CSV</MenuItem>
                </Select>
              </div>

              {/* Recipients */}
              {/* Recipients */}
              <div className="control_group">
                <label>Recipients</label>

                <div className="recipient_list">
                  {recipients.map((value, index) => (
                    <div key={index} className="recipient_row">
                      <TextField
                        placeholder="email@example.com"
                        value={value}
                        fullWidth
                        onChange={(e) => {
                          const updated = [...recipients];
                          updated[index] = e.target.value;
                          setRecipients(updated);
                        }}
                      />

                      {recipients.length > 1 && (
                        <IconButton
                          size="small"
                          className="remove_btn"
                          onClick={() =>
                            setRecipients(recipients.filter((_, i) => i !== index))
                          }
                        >
                          <CloseIcon fontSize="small" />
                        </IconButton>
                      )}
                    </div>
                  ))}
                </div>

                <button
                  type="button"
                  className="anchor_link"
                  onClick={() => setRecipients([...recipients, ""])}
                >
                  + Add recipient
                </button>
              </div>

            </div>

            {/* Footer */}
            <div className="footer_btn_flex">
              <Button
                className="btn btn_grey"
                onClick={() => setOpen(false)}
              >
                Cancel
              </Button>

              <Button
                className="btn btn_primary"
                onClick={() => setOpen(false)}
              >
                Save
              </Button>
            </div>
          </form>

        </div>
      </div>
    </Modal>
  );
}
